export default "<kt-portlet style=\"display: flex; width: 97%\"></kt-portlet>\n\n";